import { Injectable } from "@angular/core";
import 'rxjs/add/operator/toPromise';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import * as firebase from 'firebase/app';

import { tap } from 'rxjs/operators';
import { Store } from "store";

import { User, UserInfo } from "./models/user.model";

@Injectable()
export class AuthService {

  auth$ = this.afAuth.authState
    .pipe(
      tap(next => {
        if (!next) {
          this.store.set('user', null);
          this.store.set('userInfo', null);
          return;
        }

        const user: User = {
          email: next.email,
          uid: next.uid,
          authenticated: true
        }

        this.afs.doc('users/' + next.uid).valueChanges().subscribe((userInfo: UserInfo) => {
          this.store.set('user', user);
          this.store.set('userInfo', userInfo);
        })
      })
    )

  constructor(
    private store: Store,
    public afAuth: AngularFireAuth,
    private afs: AngularFirestore
  ) { }

  get authState() {
    return this.afAuth.authState;
  }

  get user() {
		return this.afAuth.auth.currentUser;
	}

  doFacebookLogin() {
    return new Promise<any>((resolve, reject) => {
      let provider = new firebase.auth.FacebookAuthProvider();
      this.afAuth.auth
        .signInWithPopup(provider)
        .then(res => {
          resolve(res);
        }, err => {
          console.log(err);
          reject(err);
        })
    })
  }

  // doTwitterLogin(){
  //   return new Promise<any>((resolve, reject) => {
  //     let provider = new firebase.auth.TwitterAuthProvider();
  //     this.afAuth.auth
  //     .signInWithPopup(provider)
  //     .then(res => {
  //       resolve(res);
  //     }, err => {
  //       console.log(err);
  //       reject(err);
  //     })
  //   })
  // }

  doGoogleLogin() {
    return new Promise<any>((resolve, reject) => {
      let provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope('profile');
      provider.addScope('email');
      this.afAuth.auth
        .signInWithPopup(provider)
        .then(res => {
          resolve(res);
        }, err => {
          console.log(err);
          reject(err);
        })
    })
  }

  doRegister(value) {
    return new Promise<any>((resolve, reject) => {
      firebase.auth().createUserWithEmailAndPassword(value.email, value.password)
        .then(res => {
          let userRef = this.afs.collection('users').doc(res.user.uid);
          
          userRef.set({
            name: '',
            second_name: '',
            phone: '',
            country: '',
            photoUrl: '',
            rol: 'user_rol' // user profile: user_rol, admin profile: admin_rol
          })
            .then(function () {
              resolve(res);
            }).catch(function (err) {
              console.log('Error Add Extra Info User', err);
            });
        }, err => reject(err))
    })
  }

  doLogin(value) {
    return new Promise<any>((resolve, reject) => {
      firebase.auth().signInWithEmailAndPassword(value.email, value.password)
        .then(res => {
          resolve(res);
        }, err => reject(err))
    })
  }

  doLogout() {
    return new Promise((resolve, reject) => {
      if (firebase.auth().currentUser) {
        this.afAuth.auth.signOut()
        resolve();
      }
      else {
        reject();
      }
    });
  }


}
